import { CookieNames, getCookie } from "./cookies";

export const SDK_FLOW = "sdk" as const;

export const isSdkFlow = (): boolean =>
  !getCookie(CookieNames.HeraRefreshToken);
